import React from 'react'
import { Container, Row } from 'reactstrap'
// import AddRows from './AddRows'
// import ChildRows from './ChildRows'
// import RowSelectionAndDeletion from './RowSelectionAndDeletion'
// import CustomFiltering from './CustomFiltering'
import TrailRequestLists from './Table'

export default function APIContainer() {
    return (
        <div>

            <Container fluid>

                <Row>
                    <TrailRequestLists />
                </Row>
            </Container>
        </div >
    )
}